import { DateTime } from "luxon"
import { useAsclepius } from "@/composables/api/asclepius"
import store from "@/store"

const state = () => ({
  subordinateProviders: []
  // <<Interface>> subordinateProviders:
  // [{
  //  providerId: String,
  //  providerFullName: String,
  //  appointmentsAwaitingApproval: Number,
  // }]
})

const getters = {
  totalSubordinateAppointmentsAwaitingApproval: (state) => {
    return state.subordinateProviders.reduce((count, subordinate) => {
      count += subordinate.appointmentsAwaitingApproval
      return count
    }, 0)
  }
}

const actions = {
  async getSubordinateProvidersAndAppointmentsAwaitingApproval({ commit }) {
    const { getProviderApi, getAvailabilityApi, callWithResponse } = useAsclepius()

    const subordinates = (
      await callWithResponse(() =>
        getProviderApi().listSubordinates({
          providerId: store.getters["me/provider"].id
        })
      )
    ).results

    const appointmentsAwaitingApproval = subordinates.map((s) => {
      return callWithResponse(() =>
        getAvailabilityApi().listAvailabilities({
          startDatetime: DateTime.now().toString(),
          endDatetime: DateTime.now().minus({ days: 30 }).toString(),
          onlyScheduledIn: true,
          onlyWaitingForApprovalIn: true,
          providerId: s.id
        })
      )
    })
    const responses = await Promise.all(appointmentsAwaitingApproval)

    let subordinateProviders = []
    for (let i = 0; i < subordinates.length; i++) {
      subordinateProviders.push({
        providerId: subordinates[i].id,
        providerFullName: subordinates[i].full_name,
        appointmentsAwaitingApproval: responses[i].results.length
      })
    }

    commit("setSubordinateProviders", { subordinateProviders })
  }
}

const mutations = {
  setSubordinateProviders(state, { subordinateProviders }) {
    state.subordinateProviders = subordinateProviders
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
